export default "__VITE_ASSET__BSWcwr5v__"